<template>
  <div class="form__filezone" @click.stop.prevent @submit.stop.prevent>
    <div class="droparea" v-show="multiple? true: (!havefiles)" :class="{'highlight':highlight, 'wrongExt':wrongExt, 'wrongSize':wrongSize}" ref="droparea" @keypress.enter.space="$refs.droparea.click()" tabindex="0" @dragenter.prevent.stop="highlight = true" @dragover.prevent.stop="highlight = true" @dragleave.prevent.stop="highlight = false" @drop.prevent.stop="highlight = false; handleDrop($event)" @click="change=false; $refs.input.click()">
      <input ref="input" @click.stop @input="oninput" class="required" type="file" :multiple="multiple" :name="name" tabindex="-1" :accept="allowedext.map(el=>'.'+el).join(',')" :required="required">
      <svg viewBox="0 0 40 40"> 
        <use href="#addfile"></use>
      </svg>
      <div class="droparea__text"><span class="red">Нажмите</span> или перетащите файл в область для загрузки*</div>
    </div>
    <p class="smallfont" v-show="multiple? true: (!havefiles)">Заявление может быть <span class="ext">в&nbsp;формате электронного документа (pdf) или фото/скан (jpg,&nbsp;png,&nbsp;heif,&nbsp;heic)</span> каждой страницы отдельно. <span class="size">Объем прикрепляемого файла не больше 15Мб</span></p>
  </div>
</template>

<script>

  export default {
    data: ()=>({
      wrongSize: false,
      wrongExt: false,
      highlight: false,
      filenames: new Set(),
      setfiles: new Set(),
      havefiles: 0,
      change: false,
      DTFiles: undefined,
      supportDataTransfer: false
    }),
    created(){
      try {
        new DataTransfer()
      } catch(err) {
        return
      }
      this.supportDataTransfer = true
    },
    props: {
      value: {default: ()=>[], type: Array},
      name: {type: String, required: true},
      multiple: {type: Boolean, default: true},
      allowedext: {type: Array, default: ()=>['jpg','jpeg','png','pdf','heif','heic']},
      required: {type: Boolean},
    },
    watch: {
      wrongSize(v, old){
        if (v && old == false)
          setTimeout(()=>this.wrongSize = false, 500)
      },
      wrongExt(v, old){
        if (v && old == false)
          setTimeout(()=>this.wrongExt = false, 500)
      }
    },
    computed:{
      DTEnabled(){
        return this.supportDataTransfer
      }
    },
    methods: {
      oninput(){
        if (this.$refs.input.value == '')
          return

        let num = this.handleFiles(this.$refs.input.files, this.change); 

        if(this.change && num) {
          this.havefiles--
          this.change.remove()
        }

        this.change = false
      },
      setFiles(deleteall){
        try {
        this.DTFiles = new DataTransfer()
        } catch (err) { this.DTFiles = undefined}
        if (this.DTFiles) {
          Array.from(this.setfiles).forEach(file=> { this.DTFiles.items.add(file)})
        }
        else {
          console.log('no DataTransfer support, clearing data...')
          if (deleteall) {
            this.$el.querySelectorAll('.file').forEach(f=>f.remove())
            this.setfiles = new Set()
            this.filenames = new Set()
            this.havefiles = 0
            this.$refs.input.value = ''
          }
        }
        this.$refs.droparea.dispatchEvent(new Event('drop'))
      },
      stopLoad(fileView){
        this.change = false
        this.fileDelete(fileView)    
      },
      fileDelete(fileView){
        this.filenames.delete(fileView.name)
        let remarray = Array.from(this.setfiles).filter(el=>el.name != fileView.name) 
        this.setfiles = new Set(remarray)
        this.havefiles--
        fileView.classList.add('deleting')
        setTimeout(()=>{fileView.remove(); }, 500)
        if (!this.havefiles) 
          this.$refs.input.value = ''

        if (this.change) return this.change = false

        this.setFiles('delete')
      },
      fileChange(fileView) {
        this.change = fileView
        this.$refs.input.click()
      },
      giveEl(tag, innerText = '', attributes = {}){
        let el
        el = window.document.createElement(tag)
        el.innerText = innerText
        for (let atr in attributes)
        el.setAttribute(atr, attributes[atr])
        el.addEventListener('click', function(e){e.preventDefault();e.stopPropagation();})
        return el
      },
      giveIcon(name, classname = false, button) {
        name = '#' + name
        let viewbox = window.document.querySelector(name).getAttribute('viewBox')
        let cont = this.giveEl('div'), icon
        cont.innerHTML = `<svg viewBox="${viewbox}"><use href="${name}"></use></svg>`
        icon = cont.querySelector('svg')
        if (button) {
          let btn = this.giveEl('button')
          btn.append(icon)
          btn.addEventListener('click', (e)=>e.preventDefault())
          icon = btn
        }
        if (classname)
        icon.setAttribute('class', classname)
        return icon
      },
      giveFile(type = 'pdf', name = 'name', size = ' 123 KB') {
        let docicon = this.giveIcon('doc')
        let doctype = this.giveEl('div', type, {'class':'doc__type'})
        let doc = this.giveEl('div', '' , {'class':'doc'})
    
        doc.append(docicon)
        doc.append(doctype)
    
        let fname = this.giveEl('div', name , {'class':'file__name'}),
            fbar = this.giveEl('div', '', {'class':'file__bar'}),
            fbarinner = this.giveEl('div', '', {'class':'file__bar file__bar_percent'}),
            fsize = this.giveEl('div', size , {'class':'file__size'}),
            fdescr = this.giveEl('div', '', {'class':'file__descr'}),
            file = this.giveEl('div', '', {'class':'file file_upload'})
        fbar.append(fbarinner)
        fdescr.append(fname, fbar, fsize)
    
        file.append(doc)
        file.append(fdescr)

        file.name = name

    
        let edit = this.giveIcon('edit', 'file__control', true),
            trash = this.giveIcon('trash', 'file__control', true),
            close = this.giveIcon('close', 'file__control close', true)
    
        let factions = this.giveEl('div', '', {'class':'file__actions'}),
            fperc = this.giveEl('div', '0', {'class':'file__percent'}),
            div = this.giveEl('div')
        div.append(edit,trash,close)
        factions.append(div, fperc)
    
        file.append(factions)
    
        close.addEventListener('click', (e)=> { this.stopLoad(file); e.preventDefault(); e.stopPropagation(); })
        trash.addEventListener('click', (e)=> { this.fileDelete(file); e.preventDefault(); e.stopPropagation(); })
        edit.addEventListener('click', (e)=> { this.fileChange(file); e.preventDefault(); e.stopPropagation(); })
        if (this.change) 
          file.classList.add('file_uploadchange')
        return [file, fbarinner, fperc]
      },
      handleFiles(files, insertTo) {
        let filecount = 0;
        if (!this.DTEnabled && files) {
          this.$el.querySelectorAll('.file').forEach(f=>f.remove())
          this.setfiles = new Set()
          this.filenames = new Set()
          this.havefiles = 0
          this.change = false
          insertTo = false
        }
        if (!this.multiple && files && files.length > 1) return
        if (!this.multiple && files && this.havefiles && files.length == 1 && !this.change) return
        if (files)
          ([...files]).forEach(f =>{
            
            let name = f.name, ext = f.name.match(/\.[^.]*$/)[0].substr(1).toLowerCase(), size = f.size
            if (!this.allowedext.includes(ext)) 
              return this.wrongExt = true

            if (size > 1024 * 1024*15)
              return this.wrongSize = true

            if(this.filenames.has(name)) return
            
            if (!this.change && !this.multiple && this.havefiles) return
              
            if (this.change) {
              this.filenames.delete(this.change.name)
              this.setfiles.delete(f)
            }
            this.filenames.add(name)

            this.setfiles.add(f)
            let ar = ['KB', 'MB', 'GB', 'TB'], sizename = 'bytes'
            for (let i = 0; size > 1024 && ar[i] ; i++) {
              size = size / 1024
              sizename = ar[i]
            }
            size = Math.round(size * 10) / 10 + ' ' + sizename
      
            let [file, fbar, fperc] = this.giveFile(ext, name, size)
            if (!insertTo) insertTo = this.$refs.droparea
            this.$refs.droparea.parentNode.insertBefore(file, insertTo)
            this.havefiles++
            this.uploadFile(f, fbar, fperc)
            filecount++
            if (insertTo != this.$refs.droparea)
              this.fileDelete(insertTo)
          })

        if (!this.havefiles) 
          this.$refs.input.value = ''
        this.$emit('input', this.setfiles.size?[...this.setfiles]:undefined)
        return filecount
      },
      showProgress(bar, percentage, loaded, size) {
        let value = Math.floor(loaded * 100 / size)
        percentage.textContent = value
        bar.style.setProperty('width',  `${value}%`)
        if (loaded == size)
          bar.closest('.file').classList.add('complete')
      },
      uploadFile(file, progressbar, percentage) {
        //Фейковая загрузка
        let speed = Math.max(5000, file.size / 200),
            size = file.size,
            loaded = 0
        let fakestep = ()=>{
          loaded += speed
          if (loaded > size)
            loaded = size
          else
            setTimeout(fakestep, 20)
          this.showProgress(progressbar, percentage, loaded, size)
        }
        fakestep()
      },
      handleDrop(e){
        this.change = false
        let dt = this.DTFiles || e.dataTransfer

        let files = dt?.files || false
        if (files)
          this.$refs.input.files = files
        this.handleFiles(files)
        this.DTFiles = undefined
      }
    }
  }
</script>

<style lang="sass">
@use 'sass:math'
$whiteF: #F7F7F7
$grey7: #797979
$dark: #250708
$greyC: #C4C4C4
$greyE: #E8E8EC
$active: #E9041E

$height: 80px
$padding: 14px

.smallfont
  font-size: 13px
  line-height: 18px
  color: colors.$gray

.red
  color: colors.$red

.form__filezone
  .file + .file
    margin-top: 33px

.doc
  position: relative
  width: 40px
  min-width: 40px
  svg
    width: 100%
  &__type
    position: absolute
    top: 18px
    left: 3px
    width: 100%
    text-align: center
    color: $active
    font-size: 7px
    font-weight: 700
    text-transform: uppercase
    border: 2.5px solid colors.$red
    border-radius: 3px
    width: fit-content
    background: white
    padding: 1.5px 2px 0px
    transform: scaleX(1.1)

@keyframes shake 
  0% 
    transform: translateX(5px)
  25% 
    transform: translateX(-5px)
  50% 
    transform: translateX(5px)
  75% 
    transform: translateX(-5px)
  100% 
    transform: translateX(0)
    

.droparea
  *, &::before, &::after
    box-sizing: border-box
  position: relative
  width: 100%
  min-height: 125px
  padding: 24px
  display: flex
  flex-direction: column
  align-items: center
  text-align: center
  background: #F7F7F7
  cursor: pointer
  transition: all .3s ease-out, outline 0s
  input
    display: none
  & + p.smallfont
    margin: 16px 0 0
  & + p.smallfont 
    span.ext, span.size
      transition: .3s ease
  &.wrongExt + p.smallfont
    animation: shake .3s linear
    span.ext
      color: #E9041E
  &.wrongSize + p.smallfont
    animation: shake .3s linear
    span.size
      color: #E9041E
  
  &::before
    content: ''
    position: absolute
    left: -1px
    top: -1px
    width: calc(100% + 2px)
    height: calc(100% + 2px)
    border: 2px dashed #E8E8EC
  &:focus::before
    border-color: #250708
  &.highlight
    border-color: #E9041E

  svg
    width: 40px
    margin-bottom: 15px
  &__text
    letter-spacing: 0
    color: #797979  
    @include for-mob
      font-size: 13px
  transition: .8s ease
  &.autohide
    overflow: hidden
  &.autohide.hidden
    opacity: 0
    position: absolute
    &+p.smallfont
      position: absolute
      opacity: 0

</style>